import { Typography } from '@mui/material';
import AuthHeader from 'components/auth/AuthHeader';
import PartialPageSpinner from 'components/PartialPageSpinner';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function CallbackScreen() {
  const [time, setTime] = useState<number>(5);
  const { t } = useTranslation();
  const decrementTime = () => {
    if (time > 0) {
      setTime(time - 1);
    }
  };
  setTimeout(decrementTime, 1000);

  return (
    <>
      <AuthHeader />
      <div className='flex justify-center mt-[250px] place-content-center'>
        <div className='flex flex-col text-center'>
          {time === 0 ? (
            <PartialPageSpinner />
          ) : (
            <>
              <Typography variant='h4'>{t('page_will_open_in')}</Typography>
              <Typography variant='h1'>{time}</Typography>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default CallbackScreen;
